import { render, staticRenderFns } from "./AreaAdmin.vue?vue&type=template&id=d3dd84a4&"
import script from "./AreaAdmin.vue?vue&type=script&lang=js&"
export * from "./AreaAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AreaAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports